import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {Flow} from "../../../flows/FlowState.js";
import {LoadingSpinner, wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../Messages";
import {PaymentMethodAcceptOrChange} from "../payment-method/components/PaymentMethodAcceptOrChange.jsx";
import {PayWithAddedCardComponent} from "../payment-method/components/PayWithAddedCardComponent";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {AddNewOrLoadCardComponent} from "../payment-method/components/AddNewOrLoadCardComponent";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Controller} from "../../../flows/Controller.js";


export class PaymentAndDonationPanelStyle extends BasePanelPageStyle {
    @styleRule
    paymentDetailsSection = {
        marginBottom: 24,
    };
}

@registerStyle(PaymentAndDonationPanelStyle)
export class PaymentAndDonationPanel extends BasePanelPage {
    forceAddCard = false;
    allowRedraw = true;

    isButtonDisabled() {
        return !Flow.donation.isValid() || !this.cardComponent?.isValid();
    }

    @wrapInSpinner
    async donate() {
        this.allowRedraw = false;

        const paymentMethod = await this.cardComponent.getPaymentMethod(Controller.paymentMethod.getScope());
        Controller.paymentMethod.update({selectedPaymentMethod: paymentMethod});
        await Flow.donation.donateInlineFlowDonate();

        // TODO @mustfix what is this?
        this.allowRedraw = true;
        this.redraw();
    }

    redraw() {
        if (this.allowRedraw) {
            super.redraw();
        }
    }

    renderExistingPaymentMethodInput() {
        if (iFrameMerchantService.isCDSPaymentMethod()) {
            // Don't allow reusing for TNR for now
            return null;
        }

        Controller.paymentMethod.autoselectPaymentMethod();

        if (Controller.paymentMethod.selectedPaymentMethod) {
            return <PaymentMethodAcceptOrChange ref="cardComponent"/>
        }

        // TODO @cleanup test or remove this complexity
        // Maybe a payment method can be unlocked from a first party cookie access
        const firstPartyPaymentMethodsExist = (iFrameUserDataService.getExtraPaymentMethodCount() > 0 && !this.forceAddCard);

        return firstPartyPaymentMethodsExist && <AddNewOrLoadCardComponent
            onAddCard={() => {
                this.forceAddCard = true;
                this.redraw();
            }}/>;
    }

    renderPaymentMethodInput() {
        // Either we can pay with an existing payment method, or just show a new payment method input
        return this.renderExistingPaymentMethodInput() ||
            <PayWithAddedCardComponent ref="cardComponent" onChange={() => this.redraw()}/>;
    }

    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.paymentDetailsSection}>
                <div className={styleSheet.title}>{Messages.paymentDetails}</div>
                {this.renderPaymentMethodInput()}
            </div>,
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,
            <MerchantButton disabled={this.isButtonDisabled()}
                            onClick={() => this.donate()}
                            className={styleSheet.actionButton}>
                {
                    // We use the string because of a weird safari bug where the first click isn't perceived.
                    Flow.donation.getDonateComponentButtonLabel().toString()
                }
            </MerchantButton>,
        ]
    }

    onMount() {
        super.onMount();
        this.redraw(); // This is for the first rendering where the button doesn't have a label.
        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
